export default __webpack_public_path__ + "static/media/footer_logo.3b9c2814.svg";